import React from 'react'
import HeaderItemImage from 'letter/components/header/header_item_image'
import HeaderItemText from 'letter/components/header/header_item_text'
import HeaderItemRectangle from 'letter/components/header/header_item_rectangle'

const HeaderDisplay = ({ items, onClick }) => {
  const displayItems = items.map((item, index) => {
    switch (item.type) {
      case 'image':
        return <HeaderItemImage data={item} key={index} />
      case 'text':
        return <HeaderItemText data={item} key={index} />
      case 'rectangle':
        return <HeaderItemRectangle data={item} key={index} />
    }
  })

  return (
    <div className='headerDisplay' onClick={onClick}>
      {displayItems}
    </div>
  )
}

export default HeaderDisplay
